export const ProfilesCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Profili',
    path: '/sistema/profili',
  },
];
